import React, {useCallback} from "react"
import { BrowserView, MobileView, isBrowser } from 'react-device-detect'

import GettheboxLogo from '../../assets/images/getthebox.png'
import GettheboxLogo2x from '../../assets/images/getthebox@2x.png'
import GettheboxLogo3x from '../../assets/images/getthebox@3x.png'

export default () => {
    const goToApp = useCallback(() => {
        window.location.href = 'getthebox://just/open';
    }, []);

    return (
        <div className={`Container ${isBrowser ? 'Container-web' : ''}`}>
            <div className="Logo-container">
                <img
                    alt="Getthebox"
                    src={GettheboxLogo}
                    srcSet={`${GettheboxLogo2x} 426w, ${GettheboxLogo3x} 639w`}
                    sizes="213px"
                />
            </div>
            {process.env.REACT_APP_DEV === 'true' && (
                <span className="Dev-notice">
                    [DEV]
                </span>
            )}
            <div className="Box-wrapper">
                <h1 className="Box-title">
                    Dziękujemy!
                </h1>
                <p className="Box-text">
                    Teraz czekaj na dalsze informacje o statusie
                    weryfikacji Twojego konta. Dostaniesz od nas
                    wiadomość e-mail oraz powiadomienie push.
                </p>
                <MobileView>
                    <div className="Button-wrapper" onClick={goToApp}>
                        <span className="Button-text">
                            Wróć do Getthebox
                        </span>
                    </div>
                </MobileView>
            </div>
            <BrowserView>
                <h2 className="Web-notice">
                    Możesz zamknąć to okno.
                </h2>
            </BrowserView>
        </div>
    )
}
